import { render } from "./gainChart.vue?vue&type=template&id=2aa9d2aa"
import script from "./gainChart.vue?vue&type=script&lang=js"
export * from "./gainChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__